import { JsonSerializable } from "@/Common/Models/JsonSerializable";
import { LuxonDateTimeParser } from "@/Common/Utilities/DateAndTime/LuxonDateTimeParser";
import { GestationalAge } from "@/Patient/Models/ObstetricalFile/GestationalAge";

class OntarioObstetricalUltrasound extends JsonSerializable {
    private _id: number;

    public rowIndex: number;
    public Date?: Date;
    public GestationalAge: GestationalAge;
    public UltrasoundAge: GestationalAge;
    public Result: OntarioObstetricalFileUltrasoundResult;
    public UseForDating?: boolean;

    constructor(fields?: Partial<OntarioObstetricalUltrasound>) {
        super({ excludedFields: ["_id"] });

        Object.assign(this, fields);
        this._id = sessionStore.newId();
        this.Result = new OntarioObstetricalFileUltrasoundResult(fields?.Result);
        this.GestationalAge = new GestationalAge(fields?.GestationalAge);
        this.UltrasoundAge = new GestationalAge(fields?.UltrasoundAge);
        this.Date = LuxonDateTimeParser.parse(fields?.Date)?.toJSDate();
    }

    public getId(): number {
        return this._id;
    }

    public hasValue(): boolean {
        return !!this.Date
            || this.GestationalAge?.hasValue()
            || this.UltrasoundAge?.hasValue()
            || !!this.UseForDating
            || this.Result?.hasValue();
    }

    public isUseForDatingDisabled(): boolean {
        return !this.Date
            || !this.UltrasoundAge.hasValue();
    }
}

class OntarioObstetricalFileUltrasoundResult {
    public Result: string;
    public NuchalTranslucencyUltrasound: string;
    public AnatomyScan: string;
    public PlacentalLocation: string;
    public SoftMarkers: string;

    constructor(fields?: Partial<OntarioObstetricalFileUltrasoundResult>) {
        Object.assign(this, fields);
    }

    public hasValue(): boolean {
        return !!this.Result?.trim()
            || !!this.NuchalTranslucencyUltrasound?.trim()
            || !!this.AnatomyScan?.trim()
            || !!this.PlacentalLocation?.trim()
            || !!this.SoftMarkers?.trim();
    }
}

export { OntarioObstetricalUltrasound };
